import './synthetic-view.component.ajscss';

import { IComponentController, IComponentOptions } from 'angular';

import { DisplayDeprecatedComponent } from '@contact/upgrade';

import templateUrl from './synthetic-view.component.ajs.html';

class SyntheticViewCtrl extends DisplayDeprecatedComponent implements IComponentController {
  public selectedDomainId;
  public showAggregated;
  public selectedIndicator;

  $onInit() {}

  onChangeSelectedDomainId({ selectedDomainId }) {
    this.selectedDomainId = selectedDomainId;
  }

  onChangeShowAggregated({ showAggregated }) {
    this.showAggregated = showAggregated;
  }

  onChangeSelectedIndicator({ selectedIndicator }) {
    this.selectedIndicator = selectedIndicator;
  }
}

export class SyntheticView implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {};
  controller = [SyntheticViewCtrl];
}

export default 'syntheticView';
